import {
  SET_STEP
} from './constants';

const reducer = (state, action) => {
  switch (action.type) {
    case SET_STEP: {
      return {
        ...state,
        step: action.payload
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

export default reducer;
